export type ManagedAccountInput = {
  username: string;
  displayName: string;
};

export type ManagedAccountValidation =
  | { ok: true; value: ManagedAccountInput }
  | { ok: false; message: string };

export function validateManagedAccount(usernameInput: string, displayNameInput: string): ManagedAccountValidation {
  const username = usernameInput.trim().toLocaleLowerCase('en-US');
  const displayName = displayNameInput.trim();

  if (username.length < 3 || username.length > 32) {
    return { ok: false, message: '用户名必须为 3–32 位字母、数字或下划线' };
  }
  if (!/^[a-z0-9_]+$/.test(username)) {
    return { ok: false, message: '用户名只能包含字母、数字或下划线；中文请填写在显示名称中' };
  }
  if (displayName.length < 1 || displayName.length > 60) {
    return { ok: false, message: '显示名称必须为 1–60 个字符' };
  }
  return { ok: true, value: { username, displayName } };
}
